angular.module('app').directive('brandComplete', [
  () => {
    let link = (scope) => {
      scope.isVisible = {
        suggestions: false,
      };

      scope.categories = [
        "1-9", "A-C", "D-F", "G-I", "J-L", "M-O", "P-R", "S-U", "V-Z"
      ];

      scope.categoriesData = [
        ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
        ['a', 'b', 'c'],
        ['d', 'e', 'f'],
        ['g', 'h', 'i'],
        ['j', 'k', 'l'],
        ['m', 'n', 'o'],
        ['p', 'q', 'r'],
        ['s', 't', 'u'],
        ['v', 'w', 'x', 'y', 'z']
      ];

      scope.filteredChoices = scope.brands;

      scope.selectedCategoryIndex = 1;
      scope.categorySelect = index => {
        scope.selectedCategoryIndex = index;
        scope.enteredtext = scope.categories[index].toLowerCase().substr(0, 1);
        scope.searchTitle();
        scope.filterItems();
        // scope.filterItemsByCategory();
      };

      scope.filterItemsByCategory = () => {
        if (!scope.enteredtext.length) {
          scope.isVisible.suggestions = false;
          return;
        }
        scope.isVisible.suggestions = true;
        scope.selectedCategoryIndex = scope.categoriesData.findIndex(cat => cat.includes(scope.enteredtext.toLowerCase().substr(0, 1)));

        scope.filteredChoices = scope.filteredChoices.filter(brand => {
          return scope.categoriesData[scope.selectedCategoryIndex].includes(brand.name.toLowerCase().substr(0, 1));
        });
      };

      scope.searchTitle = () => {
        if (scope.enteredtext.length < 0) {
          return;
        }
        scope.searchhandler('brand', scope.enteredtext, 1);
      };

      scope.viewMore = ()=> { 
        scope.searchhandler('brand', scope.enteredtext, 1);
      }

      scope.filterItems = () => {
        if (!scope.enteredtext.length) {
          scope.isVisible.suggestions = false;
          return;
        }
        scope.isVisible.suggestions = true;
        scope.filteredChoices = scope.brands.filter(brand => {
          let search = scope.enteredtext.toLowerCase();
          let name = brand.name.toLowerCase();
          return name.startsWith(search.substr(0, 1)) && name.includes(search);
        });
        scope.selectedCategoryIndex = scope.categoriesData.findIndex(cat => cat.includes(scope.enteredtext.substr(0, 1)));
        scope.filterItemsByCategory();

      };

      scope.selectItem = (choice) => {
        scope.selected = choice;
        scope.enteredtext = choice.name;
        scope.isVisible.suggestions = false;
        scope.selecthandle(scope.selecttype, choice);
      };

      scope.$watch('brands', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          scope.brands = newValue;
          scope.filteredChoices = newValue;
          scope.filterItemsByCategory();
        }
      }, true);
    };

    return {
      restrict: "E",
      templateUrl: "app/directives/dbBrandComplete/dbBrandComplete.html",
      link: link,
      scope: {
        enteredtext: "=",
        selected: "=",
        placeholder: "=",
        selecthandle: "=",
        selecttype: "=",
        disabled: "=",
        disable: "=",
        board: "=",
        brands: "=",
        searchhandler: "=",
      }
    };
  }
]);
